import { Header } from "@/components/landing/Header";
import { Hero } from "@/components/landing/Hero";
import { InfoStrip, MottoBand } from "@/components/landing/InfoStrip";
import { About } from "@/components/landing/About";
import { Equipment, Interlude } from "@/components/landing/Equipment";
import { Gallery } from "@/components/landing/Gallery";
import { Pricing } from "@/components/landing/Pricing";
import { TrialForm } from "@/components/landing/TrialForm";
import { Location } from "@/components/landing/Location";
import { Footer } from "@/components/landing/Footer";
import { WhatsAppPopup, MobileBar } from "@/components/landing/WhatsAppPopup";

export default function Landing() {
  // Light deterrent against copying images (preview / copyright)
  const blockImageMenu = (e) => {
    if (e.target && e.target.tagName === "IMG") e.preventDefault();
  };
  return (
    <div data-testid="landing-page" className="min-h-screen bg-ink" onContextMenu={blockImageMenu}>
      <Header />
      <main>
        <Hero />
        <InfoStrip />
        <MottoBand />
        <About />
        <Equipment />
        <Interlude />
        <Gallery />
        <Pricing />
        <TrialForm />
        <Location />
      </main>
      <Footer />
      <WhatsAppPopup />
      <MobileBar />
    </div>
  );
}
